module.exports = __webpack_public_path__ + "img/login.69815a2d.svg";